import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';

export const ElementBase = styled.div.attrs({
  className: createReadableClass({
    component: 'element-base'
  })
})``;
